import { makeStyles, Theme, withWidth } from '@material-ui/core';
import { WithWidth } from '@material-ui/core/withWidth';
import React from 'react';
import { Views } from './LayoutWrapper';

const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  root: {
    flexGrow: 1,
    position: 'relative',
  },
  preview: {
    height: 'calc(100vh - 88px)',
    overflow: 'hidden',
    position: 'absolute',
    right: 0,
    left: 0,
    bottom: 0,
    background: '#d8d8d8',
    [breakpoints.down('sm')]: {
      width: '100%',
      height: 'calc(100vh - 78px)',
    },
  },
  iframeWrapper: (props: Props) => {
    const isDesktop = props.width !== 'xs' && props.width !== 'sm';
    const scale = isDesktop && props.view === 'desktop' ? 0.6 : 1;
    const coef = isDesktop && props.view === 'desktop' ? 1.67 : 1;
    let width;

    if (props.view === 'mobile' && isDesktop) {
      width = 320;
    } else if (props.view === 'tablet' && isDesktop) {
      width = 770;
    }

    return {
      margin: '0 auto',
      transformOrigin: 'top left',
      width: width || `${100 * coef}%`,
      maxWidth: width ? '100%' : 'none',
      height: `${100 * coef}%`,
      transform: `scale(${scale})`,
      overflow: 'auto',
      '-webkit-overflow-scrolling': 'touch',
    };
  },
  iframe: {
    border: 0,
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
}));

type Props = {
  url: string;
  view: Views;
} & WithWidth;

export default withWidth()(function WebsitePreview(props: Props) {
  const classes = useStyles(props);
  const { url } = props;

  return (
    <div className={classes.root}>
      <div className={classes.preview}>
        <div className={classes.iframeWrapper}>
          <iframe className={classes.iframe} src={url} />
        </div>
      </div>
    </div>
  );
});
